import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { ProductPreview } from "@gorilla-technologies/customer-ui"
import { Link } from "gatsby"
import { Product } from "../types.d"

interface ProductsListProps {
  products: Product[]
  /** Column count on desktop */
  columns?: 3 | 4
}

export const ProductList = ({ products, columns = 3 }: ProductsListProps) => (
  <div
    className={`grid w-full grid-cols-2 justify-items-center gap-x-4 gap-y-6 lg:grid-cols-3 lg:gap-x-24 lg:gap-y-32 ${
      columns === 4 ? "xl:grid-cols-4 xl:gap-x-10 xl:gap-y-16" : ""
    }`}
  >
    {products.map(({ localFile, ...product }) => {
      const productImage = ["image/gif", "image/svg+xml"].includes(
        product.productType
      ) ? (
        <img
          src={product.url}
          alt={product.title}
          className="h-full w-full object-cover"
        />
      ) : (
        <GatsbyImage
          image={getImage(localFile)}
          alt={product.title}
          className="h-full w-full object-cover"
        />
      )

      return (
        <Link
          key={product.id}
          to={`/product/${product.id}`}
          className="block w-full max-w-xs"
        >
          <ProductPreview
            key={product.id}
            product={product}
            image={productImage}
          />
        </Link>
      )
    })}
  </div>
)
